import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateDirective } from '../../../../../../../components/Utilites/Directives/translate.directive';

@Component({
  selector: 'app-student-submissionform',
  imports: [
    CommonModule,
    FormsModule,
    CommonModule,
    FormsModule,
    MatCardModule,
    MatDividerModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    TranslateDirective
  ],
  templateUrl: './student-submissionform.component.html',
  styleUrl: './student-submissionform.component.scss',
})
export class StudentSubmissionformComponent {
  userId: string | null = null;
  classId: string | null = null;

  assignmentId: string | null = null;

  submissionId: string | null = null;
  submissionData = {
    header: {
      studentName: 'John Doe',
      studentId: '12345',
      onTime: true,
      submittedOn: '2025-09-30',
      assignment: {
        title: 'Mathematics Assignment 3: Quadratic Equations',
        subTitle: 'Optional assignment description if added any.....',
      },
    },
    questions: [
      {
        question: 'What is Angular?',
        answer:
          'x = (-b ± √(b² - 4ac)) / 2a Where a = 1, b = 5, and c = 6 x = (-5 ± √(25 - 24)) / 2 x = (-5 ± √1) / 2 x = (-5 ± 1) / 2 x = -3 or -2',
        grade: null,
        remarks: '',
      },
      {
        question: 'Explain dependency injection?',
        answer:
          'It allows classes to request dependencies from external sources.',
        grade: null,
        remarks: '',
      },
      {
        question: 'What is RxJS?',
        answer: 'A library for reactive programming using observables.',
        grade: null,
        remarks: '',
      },
    ],
  };

  constructor(private _router: Router, private router: ActivatedRoute) {}

  ngOnInit() {
    this.classId = this.router.snapshot?.paramMap.get('classId');
    this.userId = this.router.snapshot?.paramMap.get('staffId');
    this.assignmentId = this.router.snapshot?.paramMap.get('assignmentId');
    this.submissionId = this.router.snapshot?.paramMap.get('submissionId');
  }
  goBack() {
    this._router.navigate([
      `/assignments/staff/${this.userId}/${this.classId}/${this.assignmentId}/submissionspage`,
    ]);
  }
}
